import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection = ({
  badge,
  title,
  subtitle,
  description,
  backgroundImage,
  primaryButtonText,
  primaryButtonAction,
  secondaryButtonText,
  secondaryButtonLink,
  showButtons = true
}) => {
  return (
    <section className="hero-fullwidth">
      <div className="hero-fullwidth-slide">
        <img
          src={backgroundImage}
          alt={title}
          className="hero-fullwidth-image"
          loading="eager"
        />
        <div className="hero-fullwidth-overlay" />
        <div className="container hero-fullwidth-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-fullwidth-text"
          >
            {badge && <span className="hero-badge">{badge}</span>}
            <h1 className="hero-title">{title}</h1>
            {subtitle && <p className="hero-lead">{subtitle}</p>}
            {description && <p className="hero-subtitle">{description}</p>}
            {showButtons && (
              <div className="hero-buttons">
                {primaryButtonText && primaryButtonAction && (
                  <button
                    type="button"
                    className="btn btn-primary btn-lg"
                    onClick={primaryButtonAction}
                  >
                    {primaryButtonText}
                  </button>
                )}
                {secondaryButtonText && secondaryButtonLink && (
                  <Link to={secondaryButtonLink} className="btn btn-outline btn-lg">
                    {secondaryButtonText}
                  </Link>
                )}
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
